import React, { Component } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

// Elements
import BackToTop from "./elements/back-top";
import PageScrollTop from "./elements/page-scroll-top";

// Layout
import Header from "./layout/header";
import Footer from "./layout/footer";

// Pages
import Index from "./pages/index";
import AboutUs from "./pages/about";
import ContactUs from "./pages/contact";
import DamageInspection from "./pages/services-damage";
import CarPainting from "./pages/services-painting";
import CarService from "./pages/services-service";
import CarDetailing from "./pages/services-details";
import Faq from "./pages/faq";
import Error404 from "./pages/error-404";

// Routes
import { routes } from "./routes";

class Markup extends Component {
  render() {
    // Map paths to components
    const componentMap = {
      "/": Index,
      "/om-oss": AboutUs,
      "/kontakta-oss": ContactUs,
      "tjanster/skadeverkstad-i-goteborg-kungalv": DamageInspection,
      "tjanster/bilverkstad-goteborg-kungalv-kbscenter": CarService,
      "tjanster/rekond-tvatt-kungalv": CarDetailing,
      "tjanster/billackering-bilar-kungalv": CarPainting,
      "/vanliga-fragor-bilservice": Faq,
    };

    return (
      <>
        <BrowserRouter>
          <Routes>
            <Route element={<ThemeLayout />}>
              {routes.map(({ path }) => (
                <Route key={path} path={path} element={React.createElement(componentMap[path])} />
              ))}
            </Route>
            <Route path="*" element={<Error404 />} />
          </Routes>
          <PageScrollTop />
        </BrowserRouter>
        <BackToTop />
      </>
    );
  }
}

function ThemeLayout() {
  return (
    <>
      <Header />
      <Outlet />
      <Footer />
    </>
  );
}

export default Markup;
